import type { User } from '@/types/auth';

export const Permission = {
  TRADERS_READ: 'traders.read',
  TRADERS_MANAGE: 'traders.manage',
  REQUISITES_MANAGE: 'requisites.manage',
  PAYOUTS_SUPPORT: 'payouts.support',
  APPEALS_SUPPORT: 'appeals.support',
  TRANSACTIONS_READ: 'transactions.read',
  TRANSACTIONS_CALLBACKS_SEND: 'transactions.callbacks.send',
  TRADER_TELEGRAM_CHATS_READ: 'traders.telegram_chats.read',
  TRADER_TELEGRAM_CHATS_CREATE: 'traders.telegram_chats.create',
  TRADER_OPERATIONS_FULL: 'trader_operations.full',
  REFUND_REQUESTS_READ: 'refund_requests.read',
  REFUND_REQUESTS_MANAGE: 'refund_requests.manage',
  PENALTIES_MANAGE: 'penalties.manage',
  APPEALS_READ: 'appeals.read',
  APPEALS_RESOLVE_SUCCESS: 'appeals.resolve.success',
  APPEALS_RESOLVE_REJECT: 'appeals.resolve.reject',
  TRANSACTIONS_IN_RESOLVE_SUCCESS: 'transactions.in.resolve.success',
  SUPPORT_SHIFTS_READ: 'support_shifts.read',
  SUPPORT_SHIFTS_MANAGE: 'support_shifts.manage',
  DASHBOARD_READ: 'dashboard.read',
  MERCHANTS_READ: 'merchants.read',
  MERCHANTS_MANAGE: 'merchants.manage',
  OFFERS_READ: 'offers.read',
  OFFERS_MANAGE: 'offers.manage',
  LOSSES_READ: 'losses.read',
  LOSSES_MANAGE: 'losses.manage',
} as const;

export function hasPermission(
  user: User | null | undefined,
  permission: string,
): boolean {
  if (!user) return false;
  if (user.role === 'ADMIN') return true;
  return Boolean(user.permissions?.includes('*') || user.permissions?.includes(permission));
}
